/**
 * Created by jinbian on 20/09/2017.
 */
import { call, put } from 'redux-saga/effects';
import NewsLetterAction from '../Redux/NewsLetter';


export function* trySendEmail(api, action) {
    // make the call to the api
    const response = yield call(api.subscribeEmail, action.email);
    yield put(NewsLetterAction.updateSubscribeStatus(response.status));
}
